import SvgIcon from '@mui/material/SvgIcon';

import { normalizeSx } from '@/utils/normalizeSx';

import type { SvgIconProps } from '@mui/material/SvgIcon';

const SpotHistoryTableIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      fontSize='inherit'
      sx={[
        {
          height: '15px',
          width: '15px'
        },
        ...normalizeSx(sx)
      ]}
      viewBox='0 0 15 15'
    >
      <path
        d='M0 15V0H15V15H0ZM1.66667 4.4375H13.3333V1.66667H1.66667V4.4375ZM1.66667 8.89583H13.3333V6.10417H1.66667V8.89583ZM1.66667 13.3333H13.3333V10.5625H1.66667V13.3333ZM2.5 3.875V2.20833H4.16667V3.875H2.5ZM2.5 8.33333V6.66667H4.16667V8.33333H2.5ZM2.5 12.7917V11.125H4.16667V12.7917H2.5Z'
        fill='currentColor'
      />
    </SvgIcon>
  );
};

export default SpotHistoryTableIcon;
